import { makeStyles } from '@material-ui/core/styles';
import { getTokens } from '../../styles/tokens';

export default makeStyles(theme => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  return {
    // o Stepper é um Paper: sem a caixa, só os passos
    stepper: {
      padding: '0 0 20px',
      border: 'none',
      background: 'transparent',
      '& .MuiStepLabel-label': { fontSize: 13, fontWeight: 500, color: t.textSecondary },
      '& .MuiStepLabel-label.MuiStepLabel-active, & .MuiStepLabel-label.MuiStepLabel-completed': {
        color: t.text,
        fontWeight: 600
      },
      '& .MuiStepIcon-root': { color: t.lineStrong },
      '& .MuiStepIcon-root.MuiStepIcon-active, & .MuiStepIcon-root.MuiStepIcon-completed': {
        color: t.brand
      },
      '& .MuiStepIcon-text': { fill: t.brandOn, fontWeight: 600 },
      '& .MuiStepConnector-line': { borderColor: t.line }
    },
    buttons: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 8
    },
    // a margem fica no botão: no passo do plano não há botão e a linha some
    button: { marginTop: 20 },
    wrapper: {
      position: 'relative',
      display: 'flex',
      '&:empty': { display: 'none' }
    },
    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -2,
      marginLeft: -12,
      color: t.brand
    }
  };
});
